export default {
    name: "ChartOptionsComponent",
    defaultOptions: {
        fullWidth: true,
        responsive:true,
        legend: {
            display: false,
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
        tooltips: {
            titleMarginBottom: 10,
            titleFontColor: "#ffffff",
            titleFontSize: 14,
            bodyFontColor: "#ffffff",
            xPadding: 10,
            yPadding: 10,
            displayColors: false,
            position: 'nearest',
        },
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 10,
                right: 25,
                top: 30,
                bottom: 10,
            },
        },
        scales: {
            xAxes: [
                {
                    stacked: true,
                    gridLines: {
                        display: true,
                        drawBorder: true
                    },
                    ticks: {
                        fontColor: "#FFFFFF",
                        display: true, //this will remove only the label
                        //autoSkip: false,
                        //maxRotation: 0,
                        //minRotation: 0
                    }
                }
            ],
            yAxes: [
                {
                    stacked: false,
                    gridLines: {
                        display: true,
                        // color: "rgb(234, 236, 244)",
                        // zeroLineColor: "rgb(234, 236, 244)",
                        drawBorder: true,
                        // borderDash: [2],
                        // zeroLineBorderDash: [2]
                    },
                    ticks: {
                        display: true, //this will remove only the label
                        beginAtZero: true,
                        fontColor: "#FFFFFF"
                    }
                }
            ]
        }
    },
    getCountesChartOptions: function () {
        return {
            ...this.defaultOptions,
        }
    },
    getDuplicatesChartOptions: function () {
        return {
            ...this.defaultOptions,
        }
    },
    getCapturesChartOptions: function () {
        return {
            ...this.defaultOptions,
        }
    },
    getActivityChartOptions: function () {
        return {
            ...this.defaultOptions,
            maintainAspectRatio: false,
            scales: {
                xAxes: [
                    {
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            display: false, //this will remove only the label
                        },
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false,
                            color: "rgb(234, 236, 244)",
                            zeroLineColor: "rgb(234, 236, 244)",
                            drawBorder: false,
                            borderDash: [2],
                            zeroLineBorderDash: [2],
                        },
                        ticks: {
                            display: false, //this will remove only the label
                        },
                    },
                ],
            }
        }
    },
    getImportChartOptions: function () {
        return {
            ...this.defaultOptions,
            maintainAspectRatio: false
        }
    },
    getOriginChartOptions: function () {
        return {
            ...this.defaultOptions,
            maintainAspectRatio: false,
            layout: {
                padding: {
                    left: 10,
                    right: 25,
                    top: 25,
                    bottom: 0
                }
            },
            indexAxis: 'x',
            scales: {

                xAxes: [
                    {
                        stacked: true,
                        gridLines: {
                            display: false,
                            drawBorder: false
                        },
                        ticks: {
                            display: false //this will remove only the label
                        }
                    }
                ],
                yAxes: [
                    {
                        stacked: false,
                        gridLines: {
                            display: false,
                            color: "rgb(234, 236, 244)",
                            zeroLineColor: "rgb(234, 236, 244)",
                            drawBorder: false,
                            borderDash: [2],
                            zeroLineBorderDash: [2]
                        },
                        ticks: {
                            display: false //this will remove only the label
                        }
                    }
                ]
            },
        }
    },
    getDeliveriesChartOptions: function () {
        return {
            ...this.defaultOptions,
            indexAxis: 'x',
        }
    },
    getIntegrationsChartOptions: function () {
        return {
            ...this.defaultOptions,
            indexAxis: 'x'
        }
    },
    getFormsChartOptions: function () {
        return {
            ...this.defaultOptions,
            indexAxis: 'x'
        }
    },
    getCostChartOptions: function () {
        return {
            ...this.defaultOptions,
            indexAxis: 'x'
        }
    },
    getSaleChartOptions: function () {
        return {
            ...this.defaultOptions,
            indexAxis: 'x'
        }
    }
}